import {AuthorizationFetcher, utils} from '@wallaby-ui/core';

import SearchDataFetcher from './search_data_fetcher';
import {UserFilters} from 'src/js/model/user_filters';

/** @deprecated */
const FilterFetcher = {
  getRange(requestUrl, params) {
    const paramString = `field=${encodeURIComponent(params.field)}`;

    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}?${paramString}`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  getUserFilters(requestUrl, type) {
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${UserFilters.normalizeType(type)}`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  saveUserFilter(requestUrl, type, name, params) {
    const newParams = SearchDataFetcher.normalizeParams(params);
    const paramString = `name=${encodeURIComponent(
      name
    )}&value=${encodeURIComponent(newParams.filter)}`;
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${UserFilters.normalizeType(type)}?${paramString}`,
      {method: 'post'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processEmptyContentResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  deleteUserFilter(requestUrl, id) {
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/by-id/${encodeURIComponent(id)}`,
      {method: 'delete'}
    )
      .then(utils.FetcherUtils.processEmptyContentResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  setUserFilterDefault(requestUrl, id, value) {
    const paramString = `default=${encodeURIComponent(value)}`;
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/setDefault/${encodeURIComponent(id)}?${paramString}`,
      {method: 'post'}
    )
      .then(utils.FetcherUtils.processEmptyContentResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  deleteUserFilters(requestUrl, type) {
    return FilterFetcher.deleteUserFilter(requestUrl, type);
  },
};

export default FilterFetcher;
